/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  MealTypeJsonldMealTypeRead,
  MealTypeJsonldMealTypeWrite,
  MealTypeMealTypeWrite
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type mealType_postResponse201 = {
  data: MealTypeJsonldMealTypeRead
  status: 201
}

export type mealType_postResponse400 = {
  data: void
  status: 400
}

export type mealType_postResponse422 = {
  data: void
  status: 422
}

export type mealType_postResponseSuccess = (mealType_postResponse201) & {
  headers: Headers;
};
export type mealType_postResponseError = (mealType_postResponse400 | mealType_postResponse422) & {
  headers: Headers;
};

export type mealType_postResponse = (mealType_postResponseSuccess | mealType_postResponseError)

export const getMealTypePostUrl = () => {




  return `/api/meal-type`
}

/**
 * Creates a MealType resource.
 * @summary Creates a MealType resource.
 */
export const mealType_post = async (mealTypePostBody: MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite, options?: RequestInit): Promise<mealType_postResponse> => {

  return apiCatalog<mealType_postResponse>(getMealTypePostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(mealTypePostBody)
  }
);}





export const getMealTypePostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mealType_post>>, TError,{data: MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof mealType_post>>, TError,{data: MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite}, TContext> => {

const mutationKey = ['mealTypePost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mealType_post>>, {data: MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite}> = (props) => {
          const {data} = props ?? {};

          return  mealType_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MealTypePostMutationResult = NonNullable<Awaited<ReturnType<typeof mealType_post>>>
    export type MealTypePostMutationBody = MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite
    export type MealTypePostMutationError = void

    /**
 * @summary Creates a MealType resource.
 */
export const useMealTypePost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mealType_post>>, TError,{data: MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mealType_post>>,
        TError,
        {data: MealTypeJsonldMealTypeWrite | MealTypeMealTypeWrite},
        TContext
      > => {
      return useMutation(getMealTypePostMutationOptions(options), queryClient);
    }
    export type mealType_patchResponse200 = {
  data: MealTypeJsonldMealTypeRead
  status: 200
}

export type mealType_patchResponse400 = {
  data: void
  status: 400
}

export type mealType_patchResponse404 = {
  data: void
  status: 404
}

export type mealType_patchResponse422 = {
  data: void
  status: 422
}

export type mealType_patchResponseSuccess = (mealType_patchResponse200) & {
  headers: Headers;
};
export type mealType_patchResponseError = (mealType_patchResponse400 | mealType_patchResponse404 | mealType_patchResponse422) & {
  headers: Headers;
};

export type mealType_patchResponse = (mealType_patchResponseSuccess | mealType_patchResponseError)

export const getMealTypePatchUrl = (id: string,) => {




  return `/api/meal-type/${id}`
}

/**
 * Updates the MealType resource.
 * @summary Updates the MealType resource.
 */
export const mealType_patch = async (id: string,
    mealTypeMealTypeWrite: MealTypeMealTypeWrite, options?: RequestInit): Promise<mealType_patchResponse> => {

  return apiCatalog<mealType_patchResponse>(getMealTypePatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(mealTypeMealTypeWrite)
  }
);}





export const getMealTypePatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mealType_patch>>, TError,{id: string;data: MealTypeMealTypeWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof mealType_patch>>, TError,{id: string;data: MealTypeMealTypeWrite}, TContext> => {

const mutationKey = ['mealTypePatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mealType_patch>>, {id: string;data: MealTypeMealTypeWrite}> = (props) => {
          const {id,data} = props ?? {};

          return  mealType_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MealTypePatchMutationResult = NonNullable<Awaited<ReturnType<typeof mealType_patch>>>
    export type MealTypePatchMutationBody = MealTypeMealTypeWrite
    export type MealTypePatchMutationError = void

    /**
 * @summary Updates the MealType resource.
 */
export const useMealTypePatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mealType_patch>>, TError,{id: string;data: MealTypeMealTypeWrite}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof mealType_patch>>,
        TError,
        {id: string;data: MealTypeMealTypeWrite},
        TContext
      > => {
      return useMutation(getMealTypePatchMutationOptions(options), queryClient);
    }
    export type mealType_getResponse200 = {
  data: MealTypeJsonldMealTypeRead
  status: 200
}

export type mealType_getResponse404 = {
  data: void
  status: 404
}

export type mealType_getResponseSuccess = (mealType_getResponse200) & {
  headers: Headers;
};
export type mealType_getResponseError = (mealType_getResponse404) & {
  headers: Headers;
};

export type mealType_getResponse = (mealType_getResponseSuccess | mealType_getResponseError)

export const getMealTypeGetUrl = (id: string,) => {




  return `/api/meal_types/${id}`
}

/**
 * Retrieves a MealType resource.
 * @summary Retrieves a MealType resource.
 */
export const mealType_get = async (id: string, options?: RequestInit): Promise<mealType_getResponse> => {

  return apiCatalog<mealType_getResponse>(getMealTypeGetUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMealTypeGetQueryKey = (id: string,) => {
    return [
    `/api/meal_types/${id}`
    ] as const;
    }


export const getMealTypeGetQueryOptions = <TData = Awaited<ReturnType<typeof mealType_get>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mealType_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMealTypeGetQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mealType_get>>> = ({ signal }) => mealType_get(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mealType_get>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MealTypeGetQueryResult = NonNullable<Awaited<ReturnType<typeof mealType_get>>>
export type MealTypeGetQueryError = void


export function useMealTypeGet<TData = Awaited<ReturnType<typeof mealType_get>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof mealType_get>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof mealType_get>>,
          TError,
          Awaited<ReturnType<typeof mealType_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMealTypeGet<TData = Awaited<ReturnType<typeof mealType_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mealType_get>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof mealType_get>>,
          TError,
          Awaited<ReturnType<typeof mealType_get>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMealTypeGet<TData = Awaited<ReturnType<typeof mealType_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mealType_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a MealType resource.
 */

export function useMealTypeGet<TData = Awaited<ReturnType<typeof mealType_get>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mealType_get>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMealTypeGetQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






